import {BackendFetch} from '@hantera/portal-app'
import parseJson from '@/parse-json'

export interface AuditLogEntry {
  auditLogEntryId: string
  resourcePath: string[]
  action: 'Created' | 'Updated' | 'Deleted'
  timestamp: string
  changes: AuditFieldChange[]
  identityId?: string
}

export interface AuditFieldChange {
  field: string
  oldValue: any
  newValue: any
}

export interface AuditQueryParams {
  pathPrefix?: string
  from?: string
  to?: string
  field?: string
  after?: string
  before?: string
  limit?: number
}

export interface AuditQueryResult {
  entries: AuditLogEntry[]
  hasMore: boolean
  nextCursor?: string
}

export default function (portalFetch: BackendFetch) {
  return {
    async getById(id: string): Promise<AuditLogEntry> {
      const response = await portalFetch(`/core/audit/${id}`, {
        method: 'GET'
      })

      if (!response.ok) {
        if (response.status === 404) {
          throw new Error('Audit log entry not found')
        }
        throw new Error(`Failed to fetch audit log entry: ${response.statusText}`)
      }

      const data = parseJson(await response.text())
      return data as AuditLogEntry
    },

    async query(params: AuditQueryParams): Promise<AuditQueryResult> {
      const queryParams = new URLSearchParams()

      if (params.pathPrefix) {
        queryParams.set('pathPrefix', params.pathPrefix)
      }
      if (params.from) {
        queryParams.set('from', params.from)
      }
      if (params.to) {
        queryParams.set('to', params.to)
      }
      if (params.field) {
        queryParams.set('field', params.field)
      }
      if (params.after) {
        queryParams.set('after', params.after)
      }
      if (params.before) {
        queryParams.set('before', params.before)
      }
      if (params.limit !== undefined) {
        queryParams.set('limit', params.limit.toString())
      }

      const response = await portalFetch(`/core/audit?${queryParams}`, {
        method: 'GET'
      })

      if (!response.ok) {
        throw new Error(`Failed to fetch audit logs: ${response.statusText}`)
      }

      const data = parseJson(await response.text())

      return {
        entries: data.entries || [],
        hasMore: data.hasMore || false,
        nextCursor: data.nextCursor
      }
    }
  }
}
